export default __webpack_public_path__ + "static/media/2168.6fb564c9.png";